import TableList from "@components/templates/tablelist";
import {
    HttpPlanBillList,
    HttpAllSureBill,
    HttpRebackAuditPlanBill,
    HttpSubmiPlanBill,
    HttpCancelPlanBill,
    HttpAllSubmitOutbound,
    HttpAllCancelOutbound,
    HttpAllBatchSureBill,
    HttpReprocessPlanBill,
    HttpBackToNormalPlanBill,
    HttpGetBillSpan
} from "@/service/allotment";
import {
    mapGetters
} from "vuex";
import mixin from "../mixin";
import compDetail from './update';
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,

    },
    data() {
        return {
            isMixin: true,
            Tools: {
                show: true
            },
            Tabs: {
                show: true,
                // key: 'EQ_transferOutboundPlanStatus'
            },
            formData: {
                search: {
                    'quanbu': 0,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {
                show: true
            },
            spanTabs: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillList,
        spanAjaxRequest: HttpGetBillSpan,
        interceptRequest(params) {
            return this.handleParams(params);
        },
        handleParams(params) {
            const { trackingNo, sku } = params.search;
            params.trackingNo = trackingNo;
            params.sku = sku;

            if (params.search.quanbu === 0) {
                params.search.EQ_transferOutboundPlanStatus = '';
            }
            if (params.search.error === 1) {
                params.search.IN_errorCode = [1, 2];
            } else if (params.search.error === 3) {
                params.search.IN_errorCode = [3, 4];
            } else if (params.search.error === 5) {
                params.search.EQ_errorCode = 5;
            } else if (params.search.error === 7) {
                params.search.IN_errorCode = [6, 7];
            } else if (params.search.error === 8) {
                params.search.IN_errorCode = [8, 9];
            } else if (params.search.error === 11) {
                params.search.IN_errorCode = [11, 12];
            } else if (params.search.error === 14) {
                params.search.IN_errorCode = [14, 15];
            } else if (params.search.error === 18) {
                params.search.EQ_errorCode = 18;
            } else if (params.search.error === 19) {
                params.search.IN_errorCode = [19, 20];
            }
            delete params.search.error
            delete params.search.quanbu
            delete params.search.trackingNo;
            delete params.search.sku
            /*  this.formData = params */
            return params
        },
        handleOperates(data = "", type, batch) {
            if (batch === true) {
                data = (data || this.checkedData.join(',')) + '';
                if (!data.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'allotUpdateBill',
                        params: {
                            type: "add"
                        }
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'allotUpdateBill',
                        params: {
                            type: "edit"
                        },
                        query: {
                            id: data
                        },
                    });
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "allotUpdateBill",
                        params: {
                            type: 'query'
                        },
                        query: {
                            id: data
                        },
                    }).href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('fbb.alloment.detail', { defaultValue: '详情' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: data,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        params: {
                            id: data
                        },
                        ajaxRequest: HttpSubmiPlanBill,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            id: data
                        },
                        ajaxRequest: HttpCancelPlanBill,
                        formdata: [{
                            tag: "vTextarea",
                            key: "cancelReason",
                            labelWidth: 'auto',
                            span: 24,
                            label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                        }]
                    };
                    break;
                case "rebackaudit":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                        width: 460,
                        params: {
                            id: data
                        },
                        ajaxRequest: HttpRebackAuditPlanBill,
                    };
                    break;
                case "sure":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            id: data
                        },
                        ajaxRequest: HttpAllSureBill,
                        formdata: [{
                            tag: "vTextarea",
                            key: "remark",
                            labelWidth: 'auto',
                            span: 24,
                            label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            required: false,
                        }]
                    };
                    break;
                case "allsure":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.alloment.muti_confirm', { defaultValue: "批量确认" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            ids: data
                        },
                        ajaxRequest: HttpAllBatchSureBill,
                        formdata: [{
                            tag: "vTextarea",
                            key: "remark",
                            labelWidth: 'auto',
                            span: 24,
                            label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            required: false,
                        }]
                    };
                    break;
                case "allsubmit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: this.$t('fbb.alloment.muti_commit', { defaultValue: "批量提交" }),
                        params: {
                            ids: data
                        },
                        ajaxRequest: HttpAllSubmitOutbound,
                    };
                    break;
                case "allcancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.alloment.muti_cancel', { defaultValue: "批量取消" }),
                        width: 460,
                        showDesc: false,
                        params: {
                            ids: data
                        },
                        ajaxRequest: HttpAllCancelOutbound,
                        formdata: [{
                            tag: "vTextarea",
                            key: "cancelReason",
                            labelWidth: 'auto',
                            span: 24,
                            label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                        }]
                    };
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/batchImport",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs("/static/template/transfer_plan.xls", {}, {
                                executor: 'download',
                                type: 'url'
                            });
                            // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/transferOutboundPlanTemplate", {}, 'download');
                        }
                    };
                    break;
                case 'reprocess':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                        width: 400,
                        showDesc: true,
                        params: {
                            id: data,
                            type: 1
                        },
                        ajaxRequest: HttpReprocessPlanBill,
                    };
                    break;
                case 'backToNormal':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                        width: 400,
                        showDesc: true,
                        params: {
                            id: data,
                            type: 1
                        },
                        ajaxRequest: HttpBackToNormalPlanBill,
                    };
                    break;

                case 'export':

                    this.handleParams(this.formData)
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/batchExport", this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const {
                id,
                transferOutboundPlanStatus: status,
                orderType: orderType,
                errorCode
            } = row
            return [{
                label: this.$t('fbb.alloment.query_detail', { defaultValue: '查看详情' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: status == 0 || status == 3,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                show: status == 0 || status == 3,
                params: id,
                operate: 'submit'
            },
            {
                label: this.$t('fbb.alloment.cancel_audit', { defaultValue: '撤销审核' }),
                show: status == 5,
                params: id,
                operate: 'rebackaudit'
            }, {
                label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                show: status == 8,
                params: id,
                operate: 'sure'
            }, {
                label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                show: status == 0 || status == 3 || status == 5 || status == 6 || status == 8 || status == 10 || (status == 20 && orderType != 0 && orderType != 4) || status == 120,
                params: id,
                operate: 'cancel'
            }, {
                label: this.$t('fbb.alloment.reprocess', { defaultValue: '重处理' }),
                show: errorCode !== 0,
                params: id,
                operate: 'reprocess'
            }, {
                label: this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }),
                show: errorCode !== 0,
                params: id,
                operate: 'backToNormal'
            }
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getFBBFilterDisabledAllWarehouse']),
        TabsData() {
            return [{
                name: this.$t('fbb.alloment.all', { defaultValue: "所有" }),
                key: 'quanbu',
                val: 0,
                spanKey: 'allQty',
            }, {
                name: this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
                key: 'EQ_transferOutboundPlanStatus',
                value: 0,
                spanKey: 'draftQty',
            }, {
                name: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                key: 'EQ_transferOutboundPlanStatus',
                value: 5,
                spanKey: 'submittedQty',
            }, {
                name: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                key: 'EQ_transferOutboundPlanStatus',
                value: 3,
                spanKey: 'refusedQty',
            }, {
                name: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                key: 'EQ_transferOutboundPlanStatus',
                value: 8,
                spanKey: 'sureQty',
            }, {
                name: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                key: 'EQ_transferOutboundPlanStatus',
                value: 120,
                spanKey: 'cancelErrorQty',
            }, {
                name: this.$t('fbb.alloment.exception_order', { defaultValue: "异常单据" }),
                key: 'NE_errorCode',
                value: 0,
                spanKey: 'errorQty',
            }]
        },
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            }/* ,
                {
                    name: "导出",
                    operate: "export",
                } */
                , {
                name: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                operate: "upload",
                more: true,
            }, {
                name: this.$t('fbb.alloment.muti_export', { defaultValue: "批量导出" }),
                operate: "export",
                more: true,
            },
            {
                name: this.$t('fbb.alloment.muti_confirm', { defaultValue: "批量确认" }),
                operate: "allsure",
                more: true,
                batch: true,
            },
            {
                name: this.$t('fbb.alloment.muti_cancel', { defaultValue: "批量取消" }),
                operate: "allcancel",
                more: true,
                batch: true,
            },
            {
                name: this.$t('fbb.alloment.muti_commit', { defaultValue: "批量提交" }),
                operate: "allsubmit",
                more: true,
                batch: true,
            },
            ]
        },
        SearchsData() {
            return [{
                label: this.$t('fbb.allotment.bill', { defaultValue: "调拨计划单" }),
                tag: 'vInput',
                key: 'CN_transferOutboundPlanNo',
                show: true,
            },
            {
                label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                tag: 'vInput',
                key: 'EQ_sourceNo',
                show: true,
            },
            {
                label: "SKU",
                tag: 'vInput',
                key: 'sku',
                show: true,
            },
            {
                label: this.$t('global.common.line', { defaultValue: "项目" }),
                tag: 'vSelect',
                key: 'EQ_lineId',
                options: this.getProductList,
                props: {
                    filterable: true,
                }
            },
            {
                label: "Tracking NO",
                tag: 'vInput',
                key: 'trackingNo',
            },
            {
                label: "Shipment ID",
                tag: 'vInput',
                key: 'EQ_shipmentId',
            },
            {
                label: "Remove Order ID",
                tag: 'vInput',
                key: 'EQ_removeOrderId',
            },
            {
                label: this.$t('fbb.alloment.order_type', { defaultValue: "单据类型" }),
                tag: 'vSelect',
                key: 'EQ_orderType',
                options: this.getBillType,
                props: {
                    filterable: true,
                }
            },
            {
                label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                tag: 'vSelect',
                key: 'EQ_inventoryType',
                options: this.getInventoryType,
                props: {
                    filterable: true,
                }
            },
            {
                label: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" }),
                tag: 'vSelect',
                key: 'IN_transferOutboundPlanStatus',
                options: this.getBillStatusSelect,
                props: {
                    filterable: true,
                    multiple: true,
                }
            },
            {
                label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                tag: 'vSelect',
                key: 'error',
                options: this.getErrorSimpleType,
            },
            {
                label: this.$t('fbb.alloment.warehouse_out', { defaultValue: "出库仓库" }),
                tag: 'vSelect',
                key: 'EQ_orgWarehouseId',
                options: this.getFBBFilterDisabledAllWarehouse,
                props: {
                    filterable: true,
                }
            },
            {
                label: this.$t('fbb.alloment.warehouse_in', { defaultValue: "入库仓库" }),
                tag: 'vSelect',
                key: 'EQ_inOrgWarehouseId',
                options: this.getFBBFilterDisabledAllWarehouse,
                props: {
                    filterable: true,
                }
            },
            {
                label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                tag: "vSelect",
                key: "EQ_hasPicture",
                options: [
                    {
                        label: this.$t('tms.ship.correct', { defaultValue: "是" }),
                        value: 1
                    },
                    {
                        label: this.$t('tms.ship.deny', { defaultValue: "否" }) ,
                        value: 0
                    }
                ],
            },
            {
                label: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                tag: 'vDatepicker',
                style: "width:362px",
                key: 'BT_createdAt',
                props: {
                    format: 'yy-mm-dd 00:00:00 ~ yy-mm-dd 23:59:59',
                    confirm: false,
                },
            }
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                maxWidth: 90,
                render: this.getOperateNodes
            },
            {
                // title: '调拨计划单号/来源单号',
                title: `${this.$t('fbb.allotment.bill', { defaultValue: '调拨计划单号' })}/${this.$t('global.common.source_number', { defaultValue: '来源单号' })}`,
                key: 'transferOutboundPlanNo',
                render: (h, {
                    row
                }) => {
                    return <div><a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')} > {row.transferOutboundPlanNo} </a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        <br /> {row.sourceNo || '--'}
                        <br /><div><span style="color:red;">{this.findRenderLabel(this.getErrorType, row.errorCode)} </span> </div>
                    </div>


                }
            },
            /*  {
                 title: '来源单号',
                 key: 'sourceNo',
             }, */
            {
                title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                key: 'orderType',
                render: (h, {
                    row
                }) => this.findRenderLabel(this.getBillType, row.orderType)
            },

            {
                title: this.$t('fbb.alloment.order_status', { defaultValue: '单据状态' }),
                key: 'transferOutboundPlanStatus',
                maxWidth: 80,
                render: (h, {
                    row
                }) => {
                    const status = row.transferOutboundPlanStatus;
                    const {
                        theme = 'default', label
                    } = this.getBillStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return (
                        <vButton ghost theme={
                            theme
                        }
                            size="small"
                            class="cursor-not width-60" > {
                                label
                            }
                        </vButton>
                    )
                }
            },
            {
                // title: '项目/库存类型',
                title: `${this.$t('global.common.line', { defaultValue: '项目' })}/${this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' })}`,
                key: 'lineName',
                render: (h, {
                    row
                }) => {
                    return <div><div> {row.lineName} </div><div> {this.findRenderLabel(this.getInventoryType, row.inventoryType)}</div></div >
                }
                // render: (h, {row}) => this.findRenderLabel(this.getProductList, row.lineId)
            },
            {
                // title: '出库仓库/入库仓库',
                title: `${this.$t('fbb.alloment.warehouse_out', { defaultValue: '出库仓库' })}/${this.$t('fbb.alloment.warehouse_in', { defaultValue: '入库仓库' })}`,
                render(h, { row }) {
                    return (
                        <div>
                            <div> {row.orgWarehouseCode || '--'} </div>
                            <div> {row.inOrgWarehouseCode || '--'} </div>
                        </div>
                    )
                }
                // render: (h, {row}) => this.findRenderLabel(this.getWarehouseAllList, row.orgWarehouseId)
            },
            /*  {
                                                title: '入库仓库',
                 key: 'inOrgWarehouseCode',
                 // render: (h, {row}) => this.findRenderLabel(this.getWarehouseAllList, row.inOrgWarehouseId)
             },
             {
                                                title: '库存类型',
                 key: 'inventoryType',
                 render: (h, {row}) => this.findRenderLabel(this.getInventoryType, row.inventoryType)
             }, */
            {
                title: 'Shipment ID/Remove Order ID',
                key: 'shipmentId',
                render: (h, {
                    row
                }) => {
                    return <div><div> {row.shipmentId || '--'} </div><div> {row.removeOrderId || '--'}</div></div >
                }
            },
            /*   {
                                                title: 'Remove Order ID',
                  key: 'removeOrderId',
              }, */
            {
                title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                key: 'updatedAt',
                sortable: true
            }/*,
{
                                    title: '异常类型',
    key: 'errorCode',
    render: (h, {
                                    row
                                }) => this.findRenderLabel(this.getErrorType, row.errorCode)
} ,
{
                                    title: '异常原因',
    key: 'errorReason',
    sortable: true
} */
            ];
        },

    },

};
